import { render, staticRenderFns } from "./GalleryTab.vue?vue&type=template&id=7b2cedee&scoped=true"
import script from "./GalleryTab.vue?vue&type=script&lang=js"
export * from "./GalleryTab.vue?vue&type=script&lang=js"
import style0 from "./GalleryTab.vue?vue&type=style&index=0&id=7b2cedee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2cedee",
  null
  
)

export default component.exports